// eslint-disable-next-line
export const VAULT_API_URL = import.meta.env.VITE_API;

export const VOTING_API_URL =
  import.meta.env.VITE_VOTING_API ||
  'https://api-voting.prd.dexfinance.com/api';

export const API_DEFAULT_URL = '';

// CG_API
export const COIN_GECKO_URL =
  'https://faas-fra1-afec6ce7.doserverless.co/api/v1/web/fn-f73a868f-1f6a-4530-95de-753d8489b619/coingecko';

export const API_COIN_GECKO_PRICE = '/getPrice?ids=';

// Googleapis
export const STORAGE_ICONS =
  'https://storage.googleapis.com/dexfinance-images-prd';

// migration
export const API_DEXFI_MIGRATION_GET_PROOFS = '/dexfi-migrations/get-proofs';
